/**
 * Biblioteca de campos pré-configurados para o FormBuilder
 * Estes campos já vêm com configurações padrão prontas para uso
 */

export const fieldLibrary = {
  // ==================== DADOS PESSOAIS ====================
  personal: {
    label: 'Dados Pessoais',
    icon: 'mdi-account',
    fields: [
      {
        name: 'nome_completo',
        label: 'Nome Completo',
        fieldTypeName: 'text',
        placeholder: 'Digite seu nome completo',
        required: true,
        layout: { cols: 12 }
      },
      {
        name: 'email',
        label: 'E-mail',
        fieldTypeName: 'email',
        placeholder: 'Digite seu e-mail',
        required: true,
        unique_value: true,
        layout: { cols: 6 }
      },
      {
        name: 'telefone',
        label: 'Telefone/WhatsApp',
        fieldTypeName: 'phone',
        placeholder: '(11) 99999-9999',
        required: true,
        layout: { cols: 6 }
      },
      {
        name: 'cpf',
        label: 'CPF',
        fieldTypeName: 'cpf',
        placeholder: '000.000.000-00',
        required: true,
        unique_value: true,
        layout: { cols: 6 }
      },
      {
        name: 'rg',
        label: 'RG',
        fieldTypeName: 'rg',
        placeholder: 'Digite seu RG',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'data_nascimento',
        label: 'Data de Nascimento',
        fieldTypeName: 'birthdate',
        placeholder: 'DD/MM/AAAA',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'genero',
        label: 'Gênero',
        fieldTypeName: 'select',
        placeholder: 'Selecione',
        required: false,
        layout: { cols: 6 },
        options: [
          { label: 'Masculino', value: 'masculino' },
          { label: 'Feminino', value: 'feminino' },
          { label: 'Não-binário', value: 'nao_binario' },
          { label: 'Prefiro não informar', value: 'nao_informar' }
        ]
      },
      {
        name: 'estado_civil',
        label: 'Estado Civil',
        fieldTypeName: 'select',
        placeholder: 'Selecione',
        required: false,
        layout: { cols: 6 },
        options: [
          { label: 'Solteiro(a)', value: 'solteiro' },
          { label: 'Casado(a)', value: 'casado' },
          { label: 'Divorciado(a)', value: 'divorciado' },
          { label: 'Viúvo(a)', value: 'viuvo' },
          { label: 'União Estável', value: 'uniao_estavel' }
        ]
      }
    ]
  },

  // ==================== DADOS PROFISSIONAIS ====================
  professional: {
    label: 'Dados Profissionais',
    icon: 'mdi-briefcase',
    fields: [
      {
        name: 'empresa',
        label: 'Empresa',
        fieldTypeName: 'text',
        placeholder: 'Nome da empresa',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'cnpj',
        label: 'CNPJ',
        fieldTypeName: 'cnpj',
        placeholder: '00.000.000/0000-00',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'cargo',
        label: 'Cargo',
        fieldTypeName: 'text',
        placeholder: 'Seu cargo na empresa',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'departamento',
        label: 'Departamento/Área',
        fieldTypeName: 'text',
        placeholder: 'Departamento ou área de atuação',
        required: false,
        layout: { cols: 6 }
      },
      {
        name: 'segmento',
        label: 'Segmento',
        fieldTypeName: 'select',
        placeholder: 'Selecione o segmento',
        required: false,
        layout: { cols: 6 },
        options: [
          { label: 'Tecnologia', value: 'tecnologia' },
          { label: 'Educação', value: 'educacao' },
          { label: 'Saúde', value: 'saude' },
          { label: 'Varejo', value: 'varejo' },
          { label: 'Indústria', value: 'industria' },
          { label: 'Serviços', value: 'servicos' },
          { label: 'Financeiro', value: 'financeiro' },
          { label: 'Outro', value: 'outro' }
        ]
      },
      {
        name: 'linkedin',
        label: 'LinkedIn',
        fieldTypeName: 'url',
        placeholder: 'https://linkedin.com/in/seu-perfil',
        required: false,
        layout: { cols: 6 }
      }
    ]
  },

  // ==================== ENDEREÇO ====================
  address: {
    label: 'Endereço',
    icon: 'mdi-map-marker',
    fields: [
      {
        name: 'cep',
        label: 'CEP',
        fieldTypeName: 'cep',
        placeholder: '00000-000',
        help_text: 'Digite o CEP para preenchimento automático',
        required: false,
        layout: { cols: 4 }
      },
      {
        name: 'endereco',
        label: 'Endereço',
        fieldTypeName: 'text',
        placeholder: 'Rua, Avenida...',
        required: false,
        layout: { cols: 8 }
      },
      {
        name: 'numero',
        label: 'Número',
        fieldTypeName: 'text',
        placeholder: 'Nº',
        required: false,
        layout: { cols: 3 }
      },
      {
        name: 'complemento',
        label: 'Complemento',
        fieldTypeName: 'text',
        placeholder: 'Apto, Sala, Bloco...',
        required: false,
        layout: { cols: 9 }
      },
      {
        name: 'bairro',
        label: 'Bairro',
        fieldTypeName: 'text',
        placeholder: 'Nome do bairro',
        required: false,
        layout: { cols: 4 }
      },
      {
        name: 'cidade',
        label: 'Cidade',
        fieldTypeName: 'city',
        placeholder: 'Nome da cidade',
        required: false,
        layout: { cols: 4 }
      },
      {
        name: 'estado',
        label: 'Estado',
        fieldTypeName: 'state',
        placeholder: 'Selecione',
        required: false,
        layout: { cols: 4 }
      }
    ]
  },

  // ==================== VESTUÁRIO/BRINDES ====================
  apparel: {
    label: 'Vestuário/Brindes',
    icon: 'mdi-tshirt-crew',
    fields: [
      {
        name: 'tamanho_camiseta',
        label: 'Tamanho de Camiseta',
        fieldTypeName: 'select',
        placeholder: 'Selecione',
        required: false,
        layout: { cols: 4 },
        options: [
          { label: 'PP', value: 'pp' },
          { label: 'P', value: 'p' },
          { label: 'M', value: 'm' },
          { label: 'G', value: 'g' },
          { label: 'GG', value: 'gg' },
          { label: 'XGG', value: 'xgg' },
          { label: 'XXGG', value: 'xxgg' }
        ]
      },
      {
        name: 'tamanho_calcado',
        label: 'Tamanho de Calçado',
        fieldTypeName: 'select',
        placeholder: 'Selecione',
        required: false,
        layout: { cols: 4 },
        options: Array.from({ length: 12 }, (_, i) => ({
          label: String(34 + i),
          value: String(34 + i)
        }))
      }
    ]
  },

  // ==================== ALIMENTAÇÃO ====================
  food: {
    label: 'Alimentação',
    icon: 'mdi-food',
    fields: [
      {
        name: 'restricao_alimentar',
        label: 'Restrição Alimentar',
        fieldTypeName: 'multiselect',
        placeholder: 'Selecione se houver',
        required: false,
        layout: { cols: 12 },
        options: [
          { label: 'Vegetariano', value: 'vegetariano' },
          { label: 'Vegano', value: 'vegano' },
          { label: 'Sem Glúten', value: 'sem_gluten' },
          { label: 'Sem Lactose', value: 'sem_lactose' },
          { label: 'Alergia a Frutos do Mar', value: 'alergia_frutos_mar' },
          { label: 'Alergia a Amendoim', value: 'alergia_amendoim' },
          { label: 'Kosher', value: 'kosher' },
          { label: 'Halal', value: 'halal' },
          { label: 'Outra', value: 'outra' }
        ]
      },
      {
        name: 'detalhes_restricao',
        label: 'Detalhes da Restrição',
        fieldTypeName: 'textarea',
        placeholder: 'Descreva sua restrição alimentar',
        required: false,
        layout: { cols: 12 }
      }
    ]
  },

  // ==================== TERMOS E ACEITES ====================
  terms: {
    label: 'Termos e Aceites',
    icon: 'mdi-checkbox-marked-circle',
    fields: [
      {
        name: 'aceite_termos',
        label: 'Aceito os Termos de Uso e Política de Privacidade',
        fieldTypeName: 'terms',
        required: true,
        layout: { cols: 12 }
      },
      {
        name: 'uso_imagem',
        label: 'Autorizo o uso da minha imagem para fins de divulgação do evento',
        fieldTypeName: 'checkbox',
        required: false,
        layout: { cols: 12 }
      },
      {
        name: 'newsletter',
        label: 'Desejo receber novidades e informações sobre próximos eventos',
        fieldTypeName: 'checkbox',
        required: false,
        layout: { cols: 12 }
      }
    ]
  }
}

/**
 * Retorna todos os campos da biblioteca em uma lista plana
 */
export const getAllLibraryFields = () => {
  const allFields = []
  Object.entries(fieldLibrary).forEach(([categoryKey, category]) => {
    category.fields.forEach(field => {
      allFields.push({
        ...field,
        category: categoryKey,
        categoryLabel: category.label
      })
    })
  })
  return allFields
}

/**
 * Busca campos na biblioteca pelo termo
 */
export const searchLibraryFields = (term) => {
  if (!term) return getAllLibraryFields()

  const lowerTerm = term.toLowerCase()
  return getAllLibraryFields().filter(field =>
    field.label.toLowerCase().includes(lowerTerm) ||
    field.name.toLowerCase().includes(lowerTerm) ||
    field.categoryLabel.toLowerCase().includes(lowerTerm)
  )
}

export default fieldLibrary
